(() => {
  function init(root = document) {
    root.querySelectorAll('[data-drv-reviews]').forEach(section => {
      if (section.dataset.drvBound) return;
      section.dataset.drvBound = 'true';
      const cards = [...section.querySelectorAll('[data-drv-review-card]')];
      const button = section.querySelector('[data-drv-more]');
      if (!button || section.dataset.editor === 'true') return;
      const pageSize = Math.max(3, Number(section.dataset.reviewPageSize) || 3);
      let visible = pageSize;
      const update = () => {
        cards.forEach((card, index) => { card.hidden = index >= visible; });
        button.hidden = visible >= cards.length;
      };
      update();
      button.addEventListener('click', () => {
        const next = cards[visible];
        visible += pageSize;
        update();
        if (next) {
          next.tabIndex = -1;
          next.focus({preventScroll:true});
          if (window.matchMedia('(max-width:749px)').matches) next.scrollIntoView({behavior:'smooth',block:'nearest',inline:'start'});
        }
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
